import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { intakeNormalize } from "@/lib/intakeNormalize";
import {
  CompanyIntake,
  HttpResponse,
  UpdateCompanyIntakeRequest,
} from "@/types";

export function useUpdateSetCompanyIntake() {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      updateCompanyIntakeRequest,
    }: {
      updateCompanyIntakeRequest: UpdateCompanyIntakeRequest;
    }) => {
      const path = `companies/${currentCompanyId}/company-intake`;
      const res = await guacHttpClient.patch<
        CompanyIntake,
        HttpResponse<CompanyIntake>,
        UpdateCompanyIntakeRequest
      >(path, updateCompanyIntakeRequest);
      return intakeNormalize.company(res.data);
    },
    onSuccess: (updatedCompanyIntake) => {
      queryClient.setQueryData(
        ["company-intake", currentCompanyId],
        updatedCompanyIntake,
      );

      void queryClient.invalidateQueries({
        queryKey: ["companies-summary"],
      });
    },
  });
}
